/* eslint-disable no-unused-vars */
import React from 'react'
import flask from '../images/flask.jpg'
import flask1 from '../images/flask1.jpg'
import flask2 from '../images/flask2.jpg'
import flask3 from '../images/flask3.jpg'
import GooeyButton from './GooeyButton'
import { serumAddress,serumAbi } from '../contracts/serums'
import claimSignatures from  "../signatures/claim";
// import { LoremIpsum } from 'react-lorem-ipsum';
import "./Burn.scss"
import { ethers } from 'ethers'

const amountOwned = [

    {
        name: "Flask of Sleepiness",
        amount_claimable: 0,
        src: flask
    },
    {
        name: "Vial of Sleep",
        amount_claimable: 0,
        src: flask1
    },
    {
        name: "Ether Elixir",
        amount_claimable: 0,
        src:flask2
    },
    {
        name: "777 Vessel",
        amount_claimable: 0,
        src: flask3
    }
]

function getIdFromName(name){
    if(name === 'Flask of Sleepiness'){
        return 1
    }
    if(name === "Vial of Sleep"){
        return 2;
    }
    if(name === "Ether Elixir"){
        return 3;
    }
    if(name === "777 Vessel"){
        return 4;
    }
}
const Claim = () => {
    const[ogStatus,setOgStatus] = React.useState(false);
    const[alreadyClaimed,setAlreadyClaimed] = React.useState(false);
    const[connected,setConnected] = React.useState(false);
    const[amountClaimableArray,setAmountClaimableArray] = React.useState(amountOwned);

  

    const claimBatch = async () => {
        try {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const userAddress = await signer.getAddress();
            const serums = new ethers.Contract(serumAddress,serumAbi,signer);

            const hasAlreadyClaimed = await serums.hasBatchClaimed(userAddress);
            if(hasAlreadyClaimed === true) {
                
                alert("You've Already Claimed");
                return;
            }
    
            const currUser = claimSignatures.find(user => user.address === userAddress);
            if(!currUser || currUser == null){
                alert("Not Eligible For Batch Claim");
            }
            const {signature,serumIds,claimAmounts} = currUser;
            console.log(signature,serumIds,claimAmounts)
        
            const claim = await serums.batchClaim(serumIds,claimAmounts,signature);
        } catch (err) {
            console.log(err);
            
        }
      
    }
    const connectHandler = async () => {
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            await provider.send("eth_requestAccounts",[]);
            const accounts = await provider.listAccounts();
            if(accounts.length>0){
                setConnected(true);
                const userAddress = accounts[0];
                const user = claimSignatures.find(obj => obj.address === userAddress);
                console.log(user);
                if(!user || user == null){
                    setOgStatus(false);
                    return;
                }
                else{
                    setOgStatus(true);
                    setAmountClaimableArray(amountClaimableArray => {
                        try{

                            let temp = amountClaimableArray;
                            for(let i = 0; i<amountClaimableArray.length;i++){
                                temp[i].amount_claimable = user.claimAmounts[i];
                            }
                            console.log(temp);
                            console.log(amountClaimableArray)
                            return temp
                        }
                        catch(err){
                            console.log(err);
                        }
                    })
                  
                }

                return
            }
        }
    }

    async function runOnRender() {
        if(!window.ethereum){
            return;
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const serums = new ethers.Contract(serumAddress,serumAbi,provider);
        const accounts = await provider.listAccounts();

        if(accounts.length>0){
            setConnected(true);
            const currUser = accounts[0];
            const checkClaim = await serums.hasBatchClaimed(currUser)
            if(checkClaim === true){
                setAlreadyClaimed(true);
              
            }
            const currObj = claimSignatures.find(user => user.address === currUser);
            if(!currObj || currObj == null) {
                
                return;
            }
            else{
                setAmountClaimableArray(amountClaimableArray => {
                    try{

                        let temp = amountClaimableArray;
                        for(let i = 0; i<amountClaimableArray.length;i++){
                            temp[i].amount_claimable = currObj.claimAmounts[i];
                        }
                        console.log(temp);
                        console.log("claimable array = ",amountClaimableArray)
                        return temp
                    }
                    catch(err){
                        console.log(err);
                    }
                })

                setOgStatus(true);
                
            }

        }
    }

    React.useEffect(() => {
        runOnRender();
    
     
    }, [])
    

  return (
      <>

    <div class=' w-screen mb-6 text-justify'>
    <div class='mt-12 flex flex-col m-auto  max-w-2xl'>
        <h1 class='text-center font-bold text-3xl'>Claim Your Passes</h1>
        {/* <LoremIpsum p={1}/> */}
    </div>
    </div>
    

    <div class=' grid grid-cols-1 gap-y-8 sm:grid-cols-2 lg:grid-cols-4  place-items-center'>
        


        {amountClaimableArray.length>0 && amountClaimableArray.map((data)=>{
            return(
             <div onClick={()=>{
                if(connected == true){
                    claimBatch();
                }
                else{
                    connectHandler();
                }
             }} class=''> 
             <img  class={`h-64 expand ${data.amount_claimable>0? "animate-pulse":""} m${getIdFromName(data.name)}`} src={data.src}></img>
             <br></br>
             <div class='text-center'>
                 <h1 class='mb-2 font-semibold'>{data.name}</h1>
                 <GooeyButton  
                 text={
                    `${data.amount_claimable && alreadyClaimed==false ?  data.amount_claimable : ""}  ${alreadyClaimed===false && ogStatus===true ? "Batch Claim" : ""}
                    ${alreadyClaimed === true? "Already Claimed" : ""}
                    ${ogStatus === false && connected==true? "Not OG": ""} 
                    ${connected == false? "Connect Wallet" : ""}

                 
                 
                 `}/>              
                 </div>
         </div>
        )})}
  

    </div>
    </>
  )
}

export default Claim